import { render, staticRenderFns } from "./runWaterMatchRecord.vue?vue&type=template&id=18235d98&scoped=true"
import script from "./runWaterMatchRecord.vue?vue&type=script&lang=js"
export * from "./runWaterMatchRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18235d98",
  null
  
)

export default component.exports